import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12f5266c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-hreport",
  role: "dialog",
  "aria-label": "Hunt reports"
}
const _hoisted_2 = { class: "nge-hreport-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hreport-kicker" }, "Hunt reports", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-hreport-title" }
const _hoisted_5 = {
  key: 0,
  class: "nge-hreport-muted"
}
const _hoisted_6 = { class: "nge-hreport-nav" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "nge-hreport-count" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "nge-hreport-what" }
const _hoisted_11 = {
  key: 0,
  class: "nge-hreport-at"
}
const _hoisted_12 = { class: "nge-hreport-when" }
const _hoisted_13 = {
  key: 0,
  class: "nge-hreport-note"
}
const _hoisted_14 = {
  key: 1,
  class: "nge-hreport-flag"
}
const _hoisted_15 = {
  key: 2,
  class: "nge-hreport-flag nge-hreport-flag--key"
}
const _hoisted_16 = {
  key: 4,
  class: "nge-hreport-adminnote"
}
const _hoisted_17 = {
  key: 5,
  class: "nge-hreport-actions"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  class: "nge-hreport-size",
  title: "How wide, across. A place of this kind already near it is made this big (the button says which); otherwise a new place this big is added. A gem anywhere in it counts."
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hreport-unit" }, "µm", -1 /* HOISTED */))
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled", "title"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 6,
  class: "nge-hreport-sizeline"
}
const _hoisted_25 = { class: "nge-hreport-noterow" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 7,
  class: "nge-hreport-done",
  role: "status"
}
const _hoisted_30 = {
  key: 8,
  class: "nge-hreport-win",
  role: "status"
}
const _hoisted_31 = {
  class: "nge-hreport-burst",
  "aria-hidden": "true"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "nge-hreport-wintitle" }, "Every report checked!", -1 /* HOISTED */))
const _hoisted_35 = { class: "nge-hreport-wintext" }
const _hoisted_36 = { class: "nge-hreport-foot" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<span class=\"nge-hreport-legend\" data-v-12f5266c><i class=\"nge-hreport-dot nge-hreport-dot--cut\" data-v-12f5266c></i>merger <i class=\"nge-hreport-dot nge-hreport-dot--merge\" data-v-12f5266c></i>extension <i class=\"nge-hreport-dot nge-hreport-dot--added\" data-v-12f5266c></i>added from a report <i class=\"nge-hreport-dot nge-hreport-dot--here\" data-v-12f5266c></i>this report</span>", 1)
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 2,
  class: "nge-hreport-muted"
}
const _hoisted_40 = {
  key: 3,
  class: "nge-hreport-error",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.queue || $setup.error || $setup.busy === 'load')
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.queue?.hunt.title || ''), 1 /* TEXT */),
          _createElementVNode("button", {
            class: "nge-hreport-x",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = $event => {$setup.close(); $setup.error = ''})
          }, "×")
        ]),
        ($setup.busy === 'load')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Loading…"))
          : ($setup.queue && $setup.report)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "nge-hreport-arrow",
                    disabled: $setup.idx === 0 || !!$setup.busy,
                    "aria-label": "The report before",
                    title: "The report before",
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.step($setup.idx - 1)))
                  }, "‹", 8 /* PROPS */, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, _toDisplayString($setup.idx + 1) + " of " + _toDisplayString($setup.queue.reports.length) + ", oldest first", 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: "nge-hreport-arrow",
                    disabled: $setup.idx >= $setup.queue.reports.length - 1 || !!$setup.busy,
                    "aria-label": "The report after",
                    title: "The report after",
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.step($setup.idx + 1)))
                  }, "›", 8 /* PROPS */, _hoisted_9),
                  _createElementVNode("span", {
                    class: _normalizeClass(["nge-hreport-open", { 'nge-hreport-open--none': !$setup.openCount }])
                  }, _toDisplayString($setup.openCount ? `${$setup.openCount} open` : 'All done'), 3 /* TEXT, CLASS */)
                ]),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("b", null, _toDisplayString($setup.report.name), 1 /* TEXT */),
                  _createTextVNode(" found a " + _toDisplayString($setup.kindWords($setup.report.kind)) + " ", 1 /* TEXT */),
                  ($setup.report.at)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "at " + _toDisplayString($setup.report.at.join(', ')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.whenOf($setup.report.t)), 1 /* TEXT */)
                ]),
                ($setup.report.note)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, "\"" + _toDisplayString($setup.report.note) + "\"", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.report.first)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _createTextVNode("Same spot as "),
                      _createElementVNode("button", {
                        class: "nge-hreport-link",
                        onClick: $setup.toFirst
                      }, _toDisplayString($setup.report.first.name) + "'s report", 1 /* TEXT */),
                      _createTextVNode(", sent first" + _toDisplayString($setup.report.first.status === 'counted' ? ' and added' : $setup.report.first.status === 'not_real' ? ' and dismissed' : '') + ".", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.keyWords)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.keyWords), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.statusWords)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 3,
                      class: _normalizeClass(["nge-hreport-status", { 'nge-hreport-status--added': $setup.report.status === 'counted' }])
                    }, _toDisplayString($setup.statusWords), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true),
                ($setup.report.admin_note && $setup.report.status !== 'open')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Note: \"" + _toDisplayString($setup.report.admin_note) + "\"", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.report.status === 'open')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "nge-hreport-btn",
                        disabled: !$setup.report.at || !!$setup.busy,
                        onClick: $setup.goThere
                      }, _toDisplayString($setup.busy === 'go' ? 'Going…' : 'Go there again'), 9 /* TEXT, PROPS */, _hoisted_18),
                      _createElementVNode("label", _hoisted_19, [
                        _createTextVNode("Size "),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.size) = $event)),
                          type: "number",
                          min: "0",
                          max: "200",
                          step: "0.5",
                          placeholder: "a point"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            $setup.size,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createTextVNode(),
                        _hoisted_20
                      ]),
                      _createElementVNode("button", {
                        class: "nge-hreport-btn nge-hreport-btn--add",
                        disabled: !!$setup.busy,
                        onClick: $setup.add
                      }, _toDisplayString($setup.busy === 'add' ? 'Adding…' : $setup.grows ? `Resize place #${$setup.grows.n}` : 'Add to the answers'), 9 /* TEXT, PROPS */, _hoisted_21),
                      ($setup.report.in_key)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "nge-hreport-btn nge-hreport-btn--same",
                            disabled: !!$setup.busy,
                            title: `Correct, but the answers have it already: nothing is added, the credit stays with the first, and ${$setup.report.name} hears they were right`,
                            onClick: $setup.same
                          }, _toDisplayString($setup.busy === 'same' ? 'Sending…' : `Same as #${$setup.report.in_key.n}`), 9 /* TEXT, PROPS */, _hoisted_22))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        class: "nge-hreport-btn",
                        disabled: !!$setup.busy,
                        onClick: $setup.dismiss
                      }, _toDisplayString($setup.busy === 'no' ? 'Dismissing…' : 'Dismiss'), 9 /* TEXT, PROPS */, _hoisted_23)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.report.status === 'open' && Number($setup.size) > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, "The teal ball in the view is " + _toDisplayString($setup.size) + " µm across: a gem anywhere in it counts." + _toDisplayString($setup.grows ? ` Place #${$setup.grows.n} is ${$setup.growsNow ? `${$setup.growsNow} µm across` : 'a point'} now.` : ''), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.note) = $event)),
                    class: "nge-hreport-noteinput",
                    maxlength: "300",
                    placeholder: $setup.report.status === 'open' ? 'A note (optional), kept with the report' : 'A note, kept with the report',
                    "aria-label": "A note on this report"
                  }, null, 8 /* PROPS */, _hoisted_26), [
                    [_vModelText, $setup.note]
                  ]),
                  _createElementVNode("label", {
                    class: "nge-hreport-tell",
                    title: `Send the note, and what you decided, to ${$setup.report.name} in the bell. Adding it always tells them; the note goes only with this ticked.`
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.tell) = $event)),
                      type: "checkbox"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, $setup.tell]
                    ]),
                    _createTextVNode(" Send to " + _toDisplayString($setup.report.name), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_27),
                  ($setup.report.status !== 'open' || ($setup.note.trim() && $setup.note.trim() !== $setup.report.admin_note))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-hreport-btn nge-hreport-btn--small",
                        disabled: !!$setup.busy || !$setup.note.trim(),
                        onClick: $setup.saveNote
                      }, _toDisplayString($setup.busy === 'note' ? 'Saving…' : 'Save note'), 9 /* TEXT, PROPS */, _hoisted_28))
                    : _createCommentVNode("v-if", true)
                ]),
                ($setup.done && !$setup.celebrate)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($setup.done), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.celebrate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.burst, (g, i) => {
                          return (_openBlock(), _createElementBlock("svg", {
                            key: i,
                            class: "nge-hreport-gem",
                            style: _normalizeStyle(g),
                            viewBox: "0 0 24 24",
                            width: "14",
                            height: "14"
                          }, _hoisted_33, 4 /* STYLE */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _hoisted_34,
                      _createElementVNode("span", _hoisted_35, _toDisplayString($setup.tally.all) + " " + _toDisplayString($setup.tally.all === 1 ? 'report' : 'reports') + ": " + _toDisplayString($setup.tally.added) + " added to the answers, " + _toDisplayString($setup.tally.same) + " correct but not first, " + _toDisplayString($setup.tally.dismissed) + " dismissed. The hunters thank you.", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-hreport-btn nge-hreport-btn--next", { 'nge-hreport-btn--primary': $setup.report.status !== 'open' }]),
                    disabled: $setup.nextOpen < 0 || !!$setup.busy,
                    onClick: _cache[6] || (_cache[6] = $event => ($setup.step($setup.nextOpen)))
                  }, "Next open ›", 10 /* CLASS, PROPS */, _hoisted_38)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : ($setup.queue)
              ? (_openBlock(), _createElementBlock("p", _hoisted_39, "No reports in this Hunt."))
              : _createCommentVNode("v-if", true),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString($setup.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}